import Vue from 'vue';
import service from './base.service'
import {AxiosPromise} from 'axios';
import {AppResponse} from '@/share/response';
import {BabyFilter, MilestoneDetailModel, SearchFilter, SearchModel} from "@/share";

export class MilestoneService extends Vue {
  private RESOURCE = 'front/milestones';

  public show(id: number | string, params: BabyFilter): AxiosPromise<AppResponse<MilestoneDetailModel>> {
    return service.get<AppResponse<MilestoneDetailModel>>(`${this.RESOURCE}/${id}`, {params: params});
  }

  public search(params: SearchFilter): AxiosPromise<AppResponse<SearchModel[]>> {
    return service.get<AppResponse<SearchModel[]>>(`${this.RESOURCE}/search`, {params: params});
  }
}
